import React from 'react';
import { Modal } from 'antd';
import { Button } from '@mui/material';
import { SelectTags } from '../Ui';

import commodities from 'assets/mock/commodities.json';

const FarmCommodities = ({ visible, row, onSuccess, onCancel }) => {

    const [selected, setSelected] = React.useState([]);

    React.useEffect(() => {
        if (row && row.id) {
            setSelected();
        } else {
            setSelected([]);
        }
    }, [row]);

    const close = () => {
        onCancel();
    }

    return (
        <React.Fragment>
            <Modal visible={visible} width={600} title="Ajoutez des Marchandises" centered footer={null} onCancel={close}>
                <SelectTags
                    data={commodities}
                    selected={selected}
                    onChange={v => {
                        setSelected(v);
                        // onSuccess('', v);
                    }}
                />

                <p className="mt-10">&nbsp;</p>
                <div className="flex justify-end">
                    <Button size="large" variant="outlined" disableElevation color="secondary" onClick={close}>
                        Annuler
                    </Button>
                    <div className="ml-8">
                        <Button size="large" variant="outlined" disableElevation color="success" onClick={() => setStep(pstep => (pstep + 1))}>
                            Continuer
                        </Button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default FarmCommodities;